import { setLocalStorage } from '@zola-helpers/client';

export enum DISABLED_MODALS {
  MAGIC_LINK_WELCOME = 'disable_magic_link_welcome',
  MAGIC_LINK_TOUR = 'disable_magic_link_tour',
}

const disableModal = (id: string): void => setLocalStorage(id, 'true');

export default disableModal;



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/addressCollection/helpers/disableModal.ts